import React from 'react';

const LOAD_STATUS = {
  ING: 'ing',
  FAILED: 'failed',
  SUCCESS: 'success',
  FIRST: 'first',
};

export { LOAD_STATUS };

export default (props) => {
  const {
    loadStatus = '',
    LoadingTpl = () => props.children || null,
    FailedTpl = () => props.children || null,
  } = props;
  return loadStatus === LOAD_STATUS.ING || loadStatus === LOAD_STATUS.FIRST ? (
    <LoadingTpl />
  ) : loadStatus === LOAD_STATUS.FAILED ? (
    <FailedTpl />
  ) : (
    props.children
  );
};
